export default __webpack_public_path__ + "static/media/icon_location_marker.799751d6.svg";